/* global angular */

(function () {
    "use strict";

    var app = angular.module('app');

    app.directive('controlMessages', [function () {
        return {
            restrict: 'E',
            templateUrl: 'partials/forms/control-messages',
            transclude: {
                'message': '?messageItems',
            },
            link: function (scope, element, attributes, model) {}
        };
    }]);

    app.directive('control', ['$http', '$templateCache', '$compile', '$parse', function ($http, $templateCache, $compile, $parse) {
        function formatLabel(string, prepend, expression) {
            string = string || '';
            prepend = prepend || '';
            var splitted = string.split(',');
            if (splitted.length > 1) {
                var formatted = splitted.shift();
                angular.forEach(splitted, function (value, index) {
                    if (expression) {
                        formatted = formatted.split('{' + index + '}').join('\' + ' + prepend + value + ' + \'');
                    } else {
                        formatted = formatted.split('{' + index + '}').join(prepend + value);
                    }
                });
                if (expression) {
                    return '\'' + formatted + '\'';
                } else {
                    return formatted;
                }
            } else {
                return prepend + string;
            }
        }
        var uniqueId = 0;
        return {
            restrict: 'A',
            templateUrl: function (element, attributes) {
                var template = 'partials/forms/control';
                switch (attributes.control) {
                    case 'textarea':
                        template = 'partials/forms/control-textarea';
                        break;
                    case 'select':
                        template = 'partials/forms/control-select';
                        break;
                    case 'checkbox':
                        template = 'partials/forms/control-checkbox';
                        break;
                    case 'radio':
                        template = 'partials/forms/control-radio';
                        break;
                    case 'switcher':
                        template = 'partials/forms/control-switcher';
                        break;
                    case 'date':
                        if (navigator.userAgent.indexOf('Firefox') !== -1) {
                            template = 'partials/forms/control-date-ff';
                        } else {
                            template = 'partials/forms/control-date';
                        }
                        break;
                    case 'file':
                        template = 'partials/forms/control-file';
                        break;
                    case 'numberpicker':
                        template = 'partials/forms/control-numberpicker';
                        break;
                }
                return template;
            },
            scope: {
                ngModel: '=',
                source: '=?',
                form: '@',
                title: '@',
                placeholder: '@',
                key: '@?',
                label: '@?',
            },
            require: 'ngModel',
            transclude: true,
            /*
            link: function(scope, element, attributes, model) {
            },
            */
            compile: function (element, attributes) {
                return {
                    pre: function (scope, element, attributes, model) {
                        var label = scope.label = (scope.label ? scope.label : 'name');
                        var key = scope.key = (scope.key ? scope.key : 'id');
                        if (attributes.control === 'select') {
                            scope.multiple = (attributes.multiple != null ? true : false);
                            var filter = (attributes.filter ? ' | ' + attributes.filter : '');
                            var optionLabel = formatLabel(label, 'item.', true);
                            scope.getOptions = function () {
                                return attributes.number ?
                                    'item.' + key + ' as ' + optionLabel + ' disable when item.disabled for item in source ' + filter :
                                    optionLabel + ' disable when item.disabled for item in source ' + filter + ' track by item.' + key;
                            }
                        }
                        if (attributes.control === 'file') {
                            scope.accept = attributes.accept || null;
                            scope.maxsize = attributes.maxsize || null;
                            scope.onBusy = function (model) {
                                $parse(attributes.onBusy)(scope.$parent);
                            };
                            scope.onComplete = function (model) {
                                $parse(attributes.onComplete)(scope.$parent);
                            };
                        }
                        var type = scope.type = attributes.control;
                        var form = scope.form = scope.form || 'form';
                        var title = scope.title = scope.title || 'untitled';
                        var placeholder = scope.placeholder = scope.placeholder || title;
                        var field = scope.field = title.replace(/[^0-9a-zA-Z]/g, "").split(' ').join('') + (++uniqueId);
                        scope.uniqueId = uniqueId;
                        scope.class = attributes.class || null;
                        scope.validation = attributes.validation || attributes.control;
                        scope.format = attributes.format || null;
                        scope.precision = attributes.precision || null;
                        scope.minLength = attributes.minLength || 0;
                        scope.maxLength = attributes.maxLength || Number.POSITIVE_INFINITY;
                        scope.min = attributes.min || null;
                        scope.max = attributes.max || null;
                        scope.rows = attributes.rows || null;
                        scope.options = $parse(attributes.options)(scope) || {};
                        scope.focus = false;
                        scope.visible = false;
                        scope.isRequired = function () {
                            return (attributes.isRequired && $parse(attributes.isRequired)(scope.$parent));
                        };
                        scope.isDisabled = function () {
                            return (attributes.isDisabled && $parse(attributes.isDisabled)(scope.$parent));
                        };
                        scope.onChange = function () {
                            // console.log('control.onChange', attributes.onChange);
                            $parse(attributes.onChange)(scope.$parent);
                        };
                        // model setter eg. numberpicker
                        scope.setValue = function (pow) {
                            var value = model.$modelValue;
                            var min = attributes.min ? ((Number($parse(attributes.min)(scope.$parent)) !== NaN) ? Number($parse(attributes.min)(scope.$parent)) : Number.NEGATIVE_INFINITY) : Number.NEGATIVE_INFINITY;
                            var max = attributes.max ? ((Number($parse(attributes.max)(scope.$parent)) !== NaN) ? Number($parse(attributes.max)(scope.$parent)) : Number.POSITIVE_INFINITY) : Number.POSITIVE_INFINITY;
                            value += pow;
                            value = Math.max(min, Math.min(max, value));
                            if (value !== model.$modelValue) {
                                model.$setViewValue(value);
                                model.$render();
                                scope.onChange();
                            }
                        };
                        scope.getType = function () {
                            var type = 'text';
                            switch (attributes.control) {
                                case 'password':
                                    // var form = $parse(scope.form)(scope.$parent);
                                    // var field = $parse(scope.form + '.' + scope.field)(scope.$parent);
                                    type = scope.visible ? 'text' : 'password';
                                    break;
                                default:
                                    type = attributes.control;
                            }
                            // console.log('control.getType', type);
                            return type;
                        };
                        scope.getClasses = function () {
                            var form = $parse(scope.form)(scope.$parent);
                            var field = $parse(scope.form + '.' + scope.field)(scope.$parent);
                            return {
                                'control-focus': scope.focus,
                                'control-success': field.$valid,
                                'control-error': field.$invalid && (form.$submitted || field.$touched),
                                'control-empty': !field.$viewValue
                            };
                        };
                        scope.getMessages = function () {
                            var form = $parse(scope.form)(scope.$parent);
                            var field = $parse(scope.form + '.' + scope.field)(scope.$parent);
                            return (form.$submitted || field.$touched) && field.$error;
                        };
                    },
                    // post: function (scope, element, attributes) { }
                };
            }
            /*
            compile: function(element, attributes) {
                element.removeAttr('my-dir'); 
                element.attr('ng-hide', 'true');
                return function(scope) {
                    $compile(element)(scope);
                };
            },
            */
        };
    }]);

    app.directive('fileModel', [
        '$parse', '$timeout',
        function ($parse, $timeout) {
            return {
                restrict: 'A',
                link: function (scope, element, attrs) {
                    var model = $parse(attrs.fileModel);
                    var modelSetter = model.assign;
                    element.bind('change', function () {
                        if (element[0].files[0] != null) {
                            $timeout(function () {
                                $parse(attrs.onBusy)(scope);
                                modelSetter(scope, element[0].files[0]);
                                read(element[0].files[0]);
                            });
                        }
                    });

                    var read = function (file) {
                        var content = $parse(attrs.fileModel + '.content');
                        var reader = new FileReader();
                        reader.onload = function () {
                            $timeout(function () {
                                content.assign(scope, reader.result);
                                $parse(attrs.onComplete)(scope);
                            })
                        }
                        reader.readAsDataURL(file);
                        //reader.readAsText(file);
                    }
                }
            };
        }
    ]);

    app.directive('numberPicker', ['$parse', '$timeout', function ($parse, $timeout) {
        return {
            restrict: 'A',
            template: '<div class="input-group">' +
                '   <span class="input-group-btn"><button class="btn btn-outline-primary" type="button">-</button></span>' +
                '   <div ng-transclude></div>' +
                '   <span class="input-group-btn"><button class="btn btn-outline-primary" type="button">+</button></span>' +
                '</div>',
            replace: true,
            transclude: true,
            link: function (scope, element, attributes, model) {
                var node = element[0];
                var nodeRemove = node.querySelectorAll('.input-group-btn > .btn')[0];
                var nodeAdd = node.querySelectorAll('.input-group-btn > .btn')[1];

                function onRemove(e) {
                    var min = $parse(attributes.min)(scope);
                    var getter = $parse(attributes.numberPicker);
                    var setter = getter.assign;
                    $timeout(function () {
                        setter(scope, Math.max(min, getter(scope) - 1));
                    });
                    // console.log('numberPicker.onRemove', min);
                }

                function onAdd(e) {
                    var max = $parse(attributes.max)(scope);
                    var getter = $parse(attributes.numberPicker);
                    var setter = getter.assign;
                    $timeout(function () {
                        setter(scope, Math.min(max, getter(scope) + 1));
                    });
                    // console.log('numberPicker.onAdd', max);
                }

                function addListeners() {
                    angular.element(nodeRemove).on('touchstart mousedown', onRemove);
                    angular.element(nodeAdd).on('touchstart mousedown', onAdd);
                }

                function removeListeners() {
                    angular.element(nodeRemove).off('touchstart mousedown', onRemove);
                    angular.element(nodeAdd).off('touchstart mousedown', onAdd);
                }
                scope.$on('$destroy', function () {
                    removeListeners();
                });
                addListeners();
            }
        };
    }]);

    app.controller('ValueCtrl', ['$scope', function ($scope) {
        /*
        $scope.init = function (data) {
            $scope.value = data;
        };
        */
    }]);

}());